export default "__VITE_ASSET__CLKvMpEA__"